/* ==========================================================================
   Margaret Victoria — behaviour for the mv-* sections.
   No dependencies. Works alongside the theme's mrk.js: add-to-cart posts to the
   native Ajax API and dispatches `ajaxProduct:added`, which the theme cart drawer
   listens for (it rebuilds itself from /cart?view=ajax and opens).
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function formatMoney(cents, format) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney && window.theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, format || theme.settings.moneyFormat);
    }
    var fmt = format || '${{amount}}';
    var n = (Number(cents) / 100).toFixed(2);
    var withCommas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(Number(cents) / 100).toLocaleString('en-CA'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','));
  }

  /* ---------------- Scroll-snap carousel helper ---------------- */
  function Carousel(track, opts) {
    this.track = track;
    this.opts = opts || {};
    this.onChange = this.opts.onChange || function () {};
    var self = this;
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { self.update(); });
    }, { passive: true });
    window.addEventListener('resize', function () { self.update(); });
    this.update();
  }
  Carousel.prototype.items = function () {
    return Array.prototype.filter.call(this.track.children, function (el) { return !el.hidden && el.offsetParent !== null; });
  };
  Carousel.prototype.index = function () {
    var items = this.items();
    var left = this.track.scrollLeft;
    var best = 0, dist = Infinity;
    for (var i = 0; i < items.length; i++) {
      var d = Math.abs(items[i].offsetLeft - this.track.offsetLeft - left);
      if (d < dist) { dist = d; best = i; }
    }
    return best;
  };
  Carousel.prototype.goTo = function (i, instant) {
    var items = this.items();
    if (!items[i]) return;
    this.track.scrollTo({ left: items[i].offsetLeft - this.track.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
  };
  Carousel.prototype.step = function (dir) {
    var items = this.items();
    if (!items.length) return;
    var w = items[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
    this.track.scrollBy({ left: dir * w, behavior: 'smooth' });
  };
  Carousel.prototype.update = function () {
    var t = this.track;
    this.atStart = t.scrollLeft <= 2;
    this.atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
    this.onChange(this.index(), this);
  };

  function bindArrows(carousel, prev, next) {
    if (prev) prev.addEventListener('click', function () { carousel.step(-1); });
    if (next) next.addEventListener('click', function () { carousel.step(1); });
    var orig = carousel.onChange;
    carousel.onChange = function (i, c) {
      if (prev) prev.disabled = c.atStart;
      if (next) next.disabled = c.atEnd;
      orig(i, c);
    };
    carousel.update();
  }

  function buildDots(container, count, carousel, label) {
    if (!container) return function () {};
    container.innerHTML = '';
    var dots = [];
    for (var i = 0; i < count; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = container.getAttribute('data-dot-class') || (container.className.split(' ')[0].replace('dots', 'dot'));
      b.setAttribute('aria-label', (label || 'Go to slide') + ' ' + (i + 1));
      (function (n) { b.addEventListener('click', function () { carousel.goTo(n); }); })(i);
      container.appendChild(b);
      dots.push(b);
    }
    return function (active) {
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === active ? 'true' : 'false'); });
    };
  }

  /* ---------------- Product section ---------------- */
  function Product(root) {
    this.root = root;
    this.colourIndex = parseInt(root.getAttribute('data-colour-index'), 10);
    this.moneyFormat = root.getAttribute('data-money-format');
    try { this.variants = JSON.parse($('[data-mv-variants]', root).textContent); } catch (e) { this.variants = []; }
    this.form = $('[data-mv-form]', root);
    this.select = $('[data-mv-variant-select]', root);
    this.qtyInput = $('[data-mv-qty]', root);
    this.initGallery();
    this.initOptions();
    this.initForm();
    this.initTiers();
    this.initShipping();
    this.current = this.findVariant(this.selectedOptions()) || this.variants[0];
  }

  Product.prototype.initGallery = function () {
    var self = this;
    var g = $('[data-mv-gallery]', this.root);
    if (!g) return;
    this.track = $('[data-mv-gallery-track]', g);
    this.thumbs = $$('[data-mv-thumb]', g);
    this.thumbTrack = $('[data-mv-thumbs]', g);
    this.dotsEl = $('[data-mv-gallery-dots]', g);
    this.gallery = new Carousel(this.track, {
      onChange: function (i) { self.syncGallery(i); },
    });
    bindArrows(this.gallery, $('[data-mv-gallery-prev]', g), $('[data-mv-gallery-next]', g));
    this.rebuildDots();
    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-media-id');
        self.showMedia(id);
      });
    });
    var tp = $('[data-mv-thumbs-prev]', g), tn = $('[data-mv-thumbs-next]', g);
    if (tp) tp.addEventListener('click', function () { self.thumbTrack.scrollBy({ left: -self.thumbTrack.clientWidth * 0.8, behavior: 'smooth' }); });
    if (tn) tn.addEventListener('click', function () { self.thumbTrack.scrollBy({ left: self.thumbTrack.clientWidth * 0.8, behavior: 'smooth' }); });
  };

  Product.prototype.rebuildDots = function () {
    var count = this.gallery.items().length;
    this.dotsEl.setAttribute('data-dot-class', 'mv-gallery__dot');
    this.setDot = buildDots(this.dotsEl, count, this.gallery, 'Show image');
    this.syncGallery(this.gallery.index());
  };

  Product.prototype.syncGallery = function (i) {
    if (!this.gallery) return;
    var slide = this.gallery.items()[i];
    if (this.setDot) this.setDot(i);
    if (!slide) return;
    var id = slide.getAttribute('data-media-id');
    var active;
    this.thumbs.forEach(function (t) {
      var on = t.getAttribute('data-media-id') === id;
      t.setAttribute('aria-current', on ? 'true' : 'false');
      if (on) active = t;
    });
    if (active && this.thumbTrack) {
      var tr = this.thumbTrack;
      var l = active.offsetLeft - tr.offsetLeft;
      if (l < tr.scrollLeft || l + active.offsetWidth > tr.scrollLeft + tr.clientWidth) {
        tr.scrollTo({ left: l - 8, behavior: 'smooth' });
      }
    }
  };

  Product.prototype.showMedia = function (mediaId, instant) {
    var items = this.gallery.items();
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-media-id') === String(mediaId)) { this.gallery.goTo(i, instant); return; }
    }
  };

  Product.prototype.filterGalleryByColour = function (colour) {
    if (!this.track) return;
    var slides = $$('[data-mv-slide]', this.track);
    var c = String(colour || '').toLowerCase();
    var matches = slides.filter(function (s) { return (s.getAttribute('data-alt') || '').toLowerCase().indexOf(c) === 0; });
    var useFilter = c && matches.length > 0;
    slides.forEach(function (s) {
      s.hidden = useFilter ? matches.indexOf(s) === -1 : false;
    });
    var visibleIds = slides.filter(function (s) { return !s.hidden; }).map(function (s) { return s.getAttribute('data-media-id'); });
    this.thumbs.forEach(function (t) { t.hidden = visibleIds.indexOf(t.getAttribute('data-media-id')) === -1; });
    this.track.scrollLeft = 0;
    this.gallery.update();
    this.rebuildDots();
  };

  Product.prototype.initOptions = function () {
    var self = this;
    this.optionInputs = $$('[data-mv-option-input]', this.root);
    this.optionInputs.forEach(function (input) {
      input.addEventListener('change', function () { self.onOptionChange(parseInt(input.getAttribute('data-mv-option-input'), 10)); });
    });
    var guide = $('[data-mv-size-guide]', this.root);
    if (guide) {
      guide.addEventListener('click', function (e) {
        var target = document.querySelector(guide.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  };

  Product.prototype.selectedOptions = function () {
    var groups = {};
    this.optionInputs.forEach(function (input) {
      if (input.checked) groups[input.getAttribute('data-mv-option-input')] = input.value;
    });
    var out = [];
    Object.keys(groups).forEach(function (k) { out[parseInt(k, 10)] = groups[k]; });
    return out;
  };

  Product.prototype.findVariant = function (opts) {
    return this.variants.find(function (v) {
      return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
    });
  };

  Product.prototype.onOptionChange = function (changedIndex) {
    var opts = this.selectedOptions();
    var variant = this.findVariant(opts);
    // Choosing a colour that is sold out in the current size: switch to the first available size of that colour.
    if ((!variant || !variant.available) && changedIndex === this.colourIndex) {
      var alt = this.variants.find(function (v) { return v.available && v.options[changedIndex] === opts[changedIndex]; });
      if (alt) variant = alt;
    }
    // Combination that doesn't exist as a variant (e.g. a size not offered in this colour):
    // keep the shopper's choice of this option and pick the closest existing variant.
    if (!variant) {
      var keep = opts[changedIndex];
      variant = this.variants.find(function (v) { return v.available && v.options[changedIndex] === keep; })
        || this.variants.find(function (v) { return v.options[changedIndex] === keep; })
        || this.variants[0];
    }
    this.setVariant(variant, changedIndex);
  };

  Product.prototype.setVariant = function (variant, changedIndex) {
    var self = this;
    var errEl = this.form && $('[data-mv-error]', this.form);
    if (errEl) errEl.textContent = '';
    this.current = variant;
    // Sync radios to the variant
    variant.options.forEach(function (value, i) {
      var input = self.optionInputs.find(function (el) { return el.getAttribute('data-mv-option-input') === String(i) && el.value === value; });
      if (input) input.checked = true;
      var label = $('[data-mv-option-value="' + i + '"]', self.root);
      if (label) label.textContent = value;
    });
    this.updateAvailability();
    if (this.select) this.select.value = String(variant.id);
    this.updatePrice(variant);
    this.updateStock(variant);
    this.updateButton(variant);
    if (changedIndex === this.colourIndex && this.colourIndex >= 0) {
      this.filterGalleryByColour(variant.options[this.colourIndex]);
    }
    if (variant.media) this.showMedia(variant.media, true);
    if (window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
    document.dispatchEvent(new CustomEvent('mv:variant-change', { detail: { variant: variant } }));
  };

  Product.prototype.updateAvailability = function () {
    var self = this;
    var opts = this.selectedOptions();
    this.optionInputs.forEach(function (input) {
      var i = parseInt(input.getAttribute('data-mv-option-input'), 10);
      var available = self.variants.some(function (v) {
        if (!v.available || v.options[i] !== input.value) return false;
        if (i === self.colourIndex) return true; // colour stays selectable; choosing it picks an available size
        return v.options.every(function (o, j) { return j === i || opts[j] === undefined || o === opts[j]; });
      });
      input.classList.toggle('is-unavailable', !available);
      var sr = input.nextElementSibling && input.nextElementSibling.querySelector('[data-mv-unavailable-label]');
      if (sr) sr.textContent = available ? '' : ' — sold out';
    });
  };

  Product.prototype.updatePrice = function (v) {
    var price = $('[data-mv-price]', this.root);
    var compare = $('[data-mv-compare]', this.root);
    var save = $('[data-mv-save]', this.root);
    if (price) price.textContent = formatMoney(v.price, this.moneyFormat);
    var onSale = v.compare > v.price;
    if (compare) { compare.hidden = !onSale; compare.textContent = onSale ? formatMoney(v.compare, this.moneyFormat) : ''; }
    if (save) {
      save.hidden = !onSale;
      if (onSale) {
        var text = save.getAttribute('data-save-type') === 'amount'
          ? 'Save ' + formatMoney(v.compare - v.price, this.moneyFormat).replace(/\.00(?=\D*$)/, '')
          : 'Save ' + Math.round(((v.compare - v.price) * 100) / v.compare) + '%';
        $('[data-mv-save-text]', save).textContent = text;
      }
    }
    this.updateTierSaving();
  };

  Product.prototype.updateStock = function (v) {
    var el = $('[data-mv-stock]', this.root);
    if (!el) return;
    var threshold = parseInt(el.getAttribute('data-threshold'), 10);
    var text = $('[data-mv-stock-text]', el);
    var state = !v.available ? 'out' : (v.qty !== null && v.qty > 0 && v.qty <= threshold ? 'low' : 'ok');
    el.classList.remove('mv-stock--ok', 'mv-stock--low', 'mv-stock--out');
    el.classList.add('mv-stock--' + state);
    el.hidden = false;
    text.textContent = state === 'out' ? el.getAttribute('data-text-out')
      : state === 'low' ? el.getAttribute('data-text-low').replace('[count]', v.qty)
      : el.getAttribute('data-text-ok');
  };

  Product.prototype.updateButton = function (v) {
    var btn = $('[data-mv-add]', this.root);
    if (!btn) return;
    btn.disabled = !v.available;
    var label = $('[data-mv-add-text]', btn);
    if (!this.labels) this.labels = { add: label.textContent.trim(), sold: 'Sold out' };
    label.textContent = v.available ? this.labels.add : this.labels.sold;
  };

  Product.prototype.initForm = function () {
    var self = this;
    if (!this.form) return;
    var btn = $('[data-mv-add]', this.form);
    var label = btn && $('[data-mv-add-text]', btn);
    if (label) this.labels = { add: btn.disabled ? 'Add to cart' : label.textContent.trim(), sold: btn.disabled ? label.textContent.trim() : 'Sold out' };
    var err = $('[data-mv-error]', this.form);
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!btn || btn.disabled) return;
      err.textContent = '';
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      var body = new FormData(self.form);
      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        body: body,
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            // Shopify refused the add (usually: no longer available). Reflect Shopify's real availability
            // instead of showing its raw message.
            var reason = res.json && res.json.description;
            self.refreshAvailability().then(function (stillAvailable) {
              err.textContent = !stillAvailable
                ? 'This option has just sold out — please choose another colour or size.'
                : (typeof reason === 'string' && reason) || 'Sorry, this item could not be added just now. Please try again.';
            });
            return;
          }
          if (document.getElementById('CartDrawer')) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.json, addToCartBtn: btn } }));
          } else {
            window.location.href = (window.theme && theme.routes && theme.routes.cartPage) || '/cart';
          }
        })
        .catch(function () { err.textContent = 'Network error — please try again.'; })
        .finally(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        });
    });
  };

  Product.prototype.refreshAvailability = function () {
    var self = this;
    var url = (this.root.getAttribute('data-product-url') || window.location.pathname.split('?')[0]) + '.js';
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return true;
        p.variants.forEach(function (fresh) {
          var v = self.variants.find(function (x) { return x.id === fresh.id; });
          if (v) v.available = fresh.available;
        });
        self.updateAvailability();
        self.updateStock(self.current);
        self.updateButton(self.current);
        return self.current ? self.current.available : true;
      })
      .catch(function () { return true; });
  };

  Product.prototype.initTiers = function () {
    var self = this;
    this.tiers = $$('[data-mv-tier]', this.root);
    this.tierSaving = $('[data-mv-tier-saving]', this.root);
    var box = $('[data-mv-multibuy]', this.root);
    this.tiersActive = box && box.getAttribute('data-active') === 'true';
    this.tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        var pressed = t.getAttribute('aria-pressed') === 'true';
        self.tiers.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        if (!pressed) t.setAttribute('aria-pressed', 'true');
        if (self.qtyInput) self.qtyInput.value = pressed ? 1 : t.getAttribute('data-qty');
        self.updateTierSaving();
      });
    });
  };

  Product.prototype.updateTierSaving = function () {
    if (!this.tierSaving || !this.tiers) return;
    var t = this.tiers.find(function (x) { return x.getAttribute('aria-pressed') === 'true'; });
    var btnLabel = this.root.querySelector('[data-mv-add-text]');
    if (!t || !this.current) {
      this.tierSaving.hidden = true;
      if (btnLabel && this.labels && this.current && this.current.available) btnLabel.textContent = this.labels.add;
      return;
    }
    var qty = parseInt(t.getAttribute('data-qty'), 10);
    var pct = parseInt(t.getAttribute('data-pct'), 10);
    var saving = Math.round((this.current.price * qty * pct) / 100);
    this.tierSaving.hidden = false;
    this.tierSaving.textContent = (this.tiersActive ? 'You save an extra ' : 'Would save an extra ') + formatMoney(saving, this.moneyFormat) + ' on ' + qty + ' items at checkout';
    if (btnLabel && this.current.available && this.labels) btnLabel.textContent = this.labels.add + ' · ' + qty + ' items';
  };

  Product.prototype.initShipping = function () {
    var el = $('[data-mv-ship]', this.root);
    if (!el) return;
    var days = parseInt(el.getAttribute('data-days'), 10) || 0;
    var d = new Date();
    var added = 0;
    for (var i = 0; i < 14 && added < Math.max(days, 1); i++) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    if (days === 0) d = new Date();
    var out = $('[data-mv-ship-date]', el);
    if (out) out.textContent = d.toLocaleDateString('en-CA', { weekday: 'short', day: 'numeric', month: 'long' }).replace(/\.$/, '');
  };

  /* ---------------- Generic sliders (reviews in collapsible, UGC, cross-sell, cart upsell) ---------------- */
  function initSlider(root) {
    var track = $('[data-mv-slider-track]', root);
    if (!track) return;
    var dotsEl = $('[data-mv-slider-dots]', root);
    var c = new Carousel(track, {});
    bindArrows(c, $('[data-mv-slider-prev]', root), $('[data-mv-slider-next]', root));
    if (dotsEl) {
      if (!dotsEl.getAttribute('data-dot-class')) dotsEl.setAttribute('data-dot-class', 'mv-slider__dot');
      var setDot = buildDots(dotsEl, c.items().length, c, 'Show item');
      var orig = c.onChange;
      c.onChange = function (i, cc) { orig(i, cc); setDot(i); };
      c.update();
    }
  }

  /* ---------------- Reviews section: filter / sort / load more ---------------- */
  function initReviews(root) {
    var grid = $('[data-mv-reviews-grid]', root);
    if (!grid) return;
    var cards = $$('[data-mv-review]', grid);
    var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 6;
    var shown = pageSize;
    var filter = 'all';
    var more = $('[data-mv-reviews-more]', root);
    var empty = $('[data-mv-reviews-empty]', root);
    var sortSel = $('[data-mv-reviews-sort]', root);
    var chips = $$('[data-mv-filter]', root);

    function matches(card) {
      if (filter === 'all') return true;
      if (filter === 'photos') return parseInt(card.getAttribute('data-photos'), 10) > 0;
      var r = Math.round(parseFloat(card.getAttribute('data-rating')));
      return filter === '3' ? r <= 3 : String(r) === filter;
    }
    function sortCards() {
      var mode = sortSel ? sortSel.value : 'recent';
      cards.sort(function (a, b) {
        var ra = parseFloat(a.getAttribute('data-rating')), rb = parseFloat(b.getAttribute('data-rating'));
        var da = a.getAttribute('data-date'), db = b.getAttribute('data-date');
        var pa = parseInt(a.getAttribute('data-photos'), 10), pb = parseInt(b.getAttribute('data-photos'), 10);
        if (mode === 'high') return rb - ra || (db > da ? 1 : -1);
        if (mode === 'low') return ra - rb || (db > da ? 1 : -1);
        if (mode === 'photos') return (pb > 0) - (pa > 0) || (db > da ? 1 : -1);
        return db > da ? 1 : db < da ? -1 : 0;
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    }
    function render() {
      var visible = 0, total = 0;
      cards.forEach(function (c) {
        if (!matches(c)) { c.hidden = true; return; }
        total++;
        c.hidden = total > shown;
        if (!c.hidden) visible++;
      });
      if (more) more.hidden = total <= shown;
      if (empty) empty.hidden = total > 0;
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        filter = chip.getAttribute('data-mv-filter');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        shown = pageSize;
        render();
      });
    });
    $$('[data-mv-dist]', root).forEach(function (row) {
      row.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); row.click(); } });
      row.addEventListener('click', function () {
        var star = parseInt(row.getAttribute('data-mv-dist'), 10);
        var key = star <= 3 ? '3' : String(star);
        var chip = chips.find(function (c) { return c.getAttribute('data-mv-filter') === key; });
        if (chip) chip.click();
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { sortCards(); render(); });
    if (more) more.addEventListener('click', function () { shown += pageSize; render(); });
    sortCards();
    render();
  }

  /* ---------------- Relative dates ("3 weeks ago") ---------------- */
  function relativeDates() {
    var now = Date.now();
    $$('time[data-mv-relative]').forEach(function (t) {
      var d = new Date(t.getAttribute('datetime') + 'T12:00:00');
      if (isNaN(d)) return;
      var days = Math.round((now - d) / 86400000);
      var text;
      if (days < 1) text = 'today';
      else if (days < 7) text = days + (days === 1 ? ' day ago' : ' days ago');
      else if (days < 30) { var w = Math.round(days / 7); text = w + (w === 1 ? ' week ago' : ' weeks ago'); }
      else if (days < 365) { var m = Math.round(days / 30); text = m + (m === 1 ? ' month ago' : ' months ago'); }
      else return;
      t.title = t.textContent;
      t.textContent = text;
    });
  }

  /* ---------------- Lightbox for review / UGC photos ---------------- */
  function initLightbox() {
    var box;
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-mv-zoom]');
      if (!trigger) return;
      e.preventDefault();
      if (!box) {
        box = document.createElement('div');
        box.className = 'mv-lightbox';
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        box.setAttribute('aria-label', 'Photo');
        box.innerHTML = '<img alt=""><button type="button" class="mv-lightbox__close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 5l14 14M19 5 5 19"/></svg></button>';
        box.addEventListener('click', function (ev) { if (ev.target === box || ev.target.closest('.mv-lightbox__close')) close(); });
        document.body.appendChild(box);
      }
      var img = box.querySelector('img');
      img.src = trigger.getAttribute('data-mv-zoom');
      box.hidden = false;
      box.querySelector('button').focus();
      document.documentElement.style.overflow = 'hidden';
      box._return = trigger;
    });
    function close() {
      box.hidden = true;
      document.documentElement.style.overflow = '';
      if (box._return) box._return.focus();
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box && !box.hidden) close(); });
  }

  /* ---------------- FAQ (one open at a time) ---------------- */
  function initFaq(root) {
    var qs = $$('[data-mv-faq-q]', root);
    qs.forEach(function (q) {
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') === 'true';
        qs.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ---------------- Announcement rotation ---------------- */
  function initAnnouncement(root) {
    var msgs = $$('.mv-announcement__message', root);
    if (msgs.length < 2) return;
    var i = 0, paused = false;
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      msgs[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % msgs.length;
      msgs[i].setAttribute('aria-hidden', 'false');
    }, parseInt(root.getAttribute('data-speed'), 10) || 5000);
  }

  /* ---------------- Cart drawer extras (upsell add, discount code) ---------------- */
  function initCartExtras() {
    // Remove a line: reuse the theme quantity selector (input → 0 → change), so the drawer rebuilds natively.
    document.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-mv-remove]');
      if (!rm) return;
      var line = rm.closest('.cart__item');
      var input = line && line.querySelector('.js-qty__num');
      if (!input || !rm.closest('#CartDrawer, .cart__page, form')) return;
      e.preventDefault();
      input.value = 0;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-mv-upsell-add]');
      if (!add) return;
      e.preventDefault();
      add.disabled = true;
      var select = add.parentNode.querySelector('select[data-mv-upsell-variant]');
      var id = select ? select.value : add.getAttribute('data-variant-id');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        credentials: 'same-origin',
      }).then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j.status) document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: j } }));
        })
        .finally(function () { add.disabled = false; });
    });
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-mv-discount-form]');
      if (!form) return;
      e.preventDefault();
      var input = form.querySelector('input');
      var msg = form.parentNode.querySelector('[data-mv-discount-msg]');
      var code = (input.value || '').trim();
      if (!code) return;
      // Native Shopify: /discount/CODE stores the code for this session; checkout validates and applies it.
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () { if (msg) msg.textContent = 'Code “' + code + '” will be applied at checkout if eligible.'; })
        .catch(function () { if (msg) msg.textContent = 'Could not save the code — you can enter it at checkout.'; });
    });
  }

  /* ---------------- Native product recommendations (cross-sell without a collection) ---------------- */
  function initRecommendations(el) {
    fetch(el.getAttribute('data-url'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var section = tmp.querySelector('.mv-crosssell');
        if (!section) { el.remove(); return; }
        el.replaceWith(section);
        $$('[data-mv-slider]', section).forEach(function (s) { s._mv = true; initSlider(s); });
      })
      .catch(function () { el.remove(); });
  }

  function init() {
    $$('[data-mv-product]').forEach(function (el) { if (!el._mv) el._mv = new Product(el); });
    $$('[data-mv-slider]').forEach(function (el) { if (!el._mv) { el._mv = true; initSlider(el); } });
    $$('[data-mv-reviews]').forEach(function (el) { if (!el._mv) { el._mv = true; initReviews(el); } });
    $$('[data-mv-faq]').forEach(function (el) { if (!el._mv) { el._mv = true; initFaq(el); } });
    $$('[data-mv-announcement]').forEach(function (el) { if (!el._mv) { el._mv = true; initAnnouncement(el); } });
    $$('[data-mv-recommendations]').forEach(function (el) { if (!el._mv) { el._mv = true; initRecommendations(el); } });
    relativeDates();
  }

  initLightbox();
  initCartExtras();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme editor: re-init sections when they reload.
  document.addEventListener('shopify:section:load', init);
  // Cart drawer content is rebuilt by the theme; re-bind sliders inside it.
  document.addEventListener('cart:updated', function () { setTimeout(init, 50); });
  document.addEventListener('ajaxProduct:added', function () { setTimeout(init, 400); });
})();
